var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "v-tabs",
            {
              model: {
                value: _vm.tab,
                callback: function callback($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c("v-tabs-slider"),
              _c(
                "v-tab",
                {
                  attrs: {
                    href: "#generate"
                  }
                },
                [_vm._v(" Generate Public/Private Keys ")]
              ),
              _c(
                "v-tab",
                {
                  attrs: {
                    href: "#import"
                  }
                },
                [_vm._v(" Import SSH Key ")]
              )
            ],
            1
          ),
          _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.tab,
                callback: function callback($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c(
                "v-tab-item",
                {
                  attrs: {
                    value: "generate"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [_vm._v(" Generate Key Pair ")]),
                      _c(
                        "gg-card-text",
                        {
                          staticClass: "pt-0"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2"
                            },
                            [
                              _vm._v(
                                " RSA vs DSA: RSA and DSA are encryption algorithms used to encrypt your key. DSA is faster for Key Generation and Signing and RSA is faster for Verification. "
                              )
                            ]
                          ),
                          _c("generate-public-key-form", {
                            on: {
                              "reload-tables": _vm.reloadTables
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-tab-item",
                {
                  attrs: {
                    value: "import"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [_vm._v(" Import SSH Key ")]),
                      _c(
                        "gg-card-text",
                        {
                          staticClass: "pt-0"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2"
                            },
                            [
                              _vm._v(
                                " You may have already generated an SSH public/private key pair. If so, you can import them here, simply paste the keys into fields below. "
                              )
                            ]
                          ),
                          _c("import-key-form", {
                            on: {
                              "reload-tables": _vm.reloadTables
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Manage Public Keys ")]),
              _c(
                "gg-card-text",
                [
                  _c("public-keys-table", {
                    attrs: {
                      "table-should-be-reloaded":
                        _vm.publicTableShouldBeReloaded
                    },
                    on: {
                      "table-reloaded": _vm.tableReloaded
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("strong", [_vm._v("NOTE")]),
                      _vm._v(
                        ": If you authorize a key that is identical to other keys, those keys may also become authorized. "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Manage Private Keys ")]),
              _c(
                "gg-card-text",
                [
                  _c("private-keys-table", {
                    attrs: {
                      "table-should-be-reloaded":
                        _vm.privateTableShouldBeReloaded
                    },
                    on: {
                      "table-reloaded": _vm.tableReloaded
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }